import Table from './table.vue'
import TableColumn from './table-column.vue'

Table.column = TableColumn
export default Table



// WEBPACK FOOTER //
// ./src/components/table/index.js